import { render, staticRenderFns } from "./icon-tile.vue?vue&type=template&id=dedd2caa&scoped=true&"
import script from "./icon-tile.vue?vue&type=script&lang=js&"
export * from "./icon-tile.vue?vue&type=script&lang=js&"
import style0 from "./icon-tile.vue?vue&type=style&index=0&id=dedd2caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd2caa",
  null
  
)

export default component.exports